import AddBoilerplate from "./AddBoilerplate";

export default AddBoilerplate;
